module.exports = __webpack_public_path__ + "static/media/header-socials-052123.085058a9.png";